<template>
  <TheLayout>
    <div class="box-storage-active">
      <div class="box-content-storage-active">
        <div class="mt-3 text-center">
          <img src="assets/warehousew.png" width="100">
        </div>
        <div class="text-head-active text-center text-bold">Chưa kích hoạt tính năng <b>Quản lý kho và Tồn kho</b></div>
        <div class="text-des-active text-center mt-3">Bên cạnh việc quản lý các hoạt động bán hàng, quản lý kho là một chức năng quan trọng. NextShop hỗ trợ kiểm soát hàng tồn kho nhanh chóng, nghiệp vụ xuất/nhập/chuyển kho chính xác, giảm thiểu tỉ lệ thất thoát đến 30%.</div>
        <div class="mt-3 line-active text-center">
          <b-button variant="primary" size="md" class="btn btn-md btn-primary" v-if="isUpload"><i class="fas fa-spinner fa-spin"></i> Đang xử lý</b-button>
          <div class="btn btn-md btn-primary" v-if="!isUpload" @click="clickEnableInventory">Kích hoạt ngay</div>
        </div>
      </div>
    </div>
    <b-modal
        v-model="popupEnableInventorySuccess"
        hide-header
        hide-footer
        no-close-on-backdrop
        centered
        title="Cập nhật tính năng kho"
        id="bv-modal-enable-inventory-success">
      <div class="box-modals">
        <div class="text-head-modal text-bold">Kích hoạt kho hàng thành công!</div>
        <div class="mt-3 text-center">
          <img src="assets/store.png" width="100">
        </div>
        <div class="text-des-modal mt-3">Từ giờ bạn đã có thể thêm sản phẩm bằng cách <b>Nhập kho, Kiểm hàng trong kho</b>, và nhiều tính năng khác!</div>
        <div class="mt-3 line-active text-right">
          <div class="text-primary cursor btn-closed" @click="clickHideInventorySuccess">Đóng</div>
        </div>
      </div>
    </b-modal>
  </TheLayout>
</template>

<script>

import { SettingService } from "@/services/nextshop/setting.service"

export default {
  
  data() {
    return {
      isUpload: false,
      popupEnableInventorySuccess: false,
      coMerchantId: JSON.parse(localStorage.getItem("auth.currentMerchant")).id
    }
  },
  created() {
   
  },
  methods: {
    async clickEnableInventory(){
      const params = {
        "coMerchantId": this.coMerchantId,
        "enableInventory": true
      }
      this.isUpload = true
      const response = await SettingService.enableInventory(params);
      if(response.success){
        this.popupEnableInventorySuccess = true
        this.isUpload = false
      }
    },
    async clickHideInventorySuccess(){
			this.popupEnableInventorySuccess = false
      this.$router.push('inventory-list')
		}
  }

}
</script>
<style scope>
  .box-storage-active{
    background: #fff;
    min-height: 700px;
    width: 100%;
    border-radius: 10px;
    padding: 100px 0;
  }
  .box-content-storage-active{
    width: 40%;
    margin: 0 auto;
  }
  .text-head-modal{
    color: #000;
    font-size: 15px;
    line-height: 20px;
    text-align: left;
    background: #f0f0f0;
    padding: 8px 10px;
  }
  .text-des-modal{
    text-align: center;
    width: 90%;
    margin: 0 auto;
    color: #000;
  }
  .box-modals .btn {
    margin: 0 5px;
  }
  .line-active{
    border-top: 1px solid #ddd;
    padding-top: 12px;
  }
  .btn-closed{
    padding:10px 15px;
  }
</style>